import { useEffect, useState } from "react";
import { Heart, X } from "@phosphor-icons/react";
import { api } from "@/lib/api";

/**
 * Shows a gentle banner when the user has a loss anniversary within ±3 days of today.
 * Dismissed banners are remembered per-anniversary in localStorage for this year.
 */
export default function AnniversaryBanner() {
  const [hit, setHit] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/loss-dates");
        const list = data.anniversaries || [];
        const year = new Date().getFullYear();
        const active = list.find(a => !localStorage.getItem(`ww_ann_${a.id}_${year}`));
        if (active) setHit(active);
      } catch {}
    })();
  }, []);

  if (!hit) return null;
  const year = new Date().getFullYear();
  const dismiss = () => {
    localStorage.setItem(`ww_ann_${hit.id}_${year}`, "1");
    setHit(null);
  };

  const label = hit.label ? `,  ${hit.label}` : "";
  let title;
  if (hit.on_day) {
    title = hit.years > 0
      ? `Today marks ${hit.years} year${hit.years > 1 ? "s" : ""} ${label}`
      : `Today ${label}`.trim();
  } else if (hit.days_until > 0) {
    title = `A tender date is coming up in ${hit.days_until} day${hit.days_until > 1 ? "s" : ""} ${label}`.trim();
  } else {
    title = `You just passed a tender date ${label}`.trim();
  }

  return (
    <div className="mb-6 relative bg-sage-50 border border-sage-100 rounded-2xl p-5 flex items-start gap-4" data-testid="anniversary-banner">
      <div className="w-10 h-10 rounded-full bg-white grid place-items-center shrink-0 shadow-soft">
        <Heart size={18} weight="duotone" className="text-coral-700" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-display text-lg leading-snug">{title}.</div>
        <p className="text-sm text-ink/70 mt-1 leading-relaxed">
          Wingwomen is holding space with you today. No task, no timeline, just a soft place to
          land if you need it.
        </p>
      </div>
      <button onClick={dismiss} data-testid="anniversary-dismiss"
              aria-label="Dismiss"
              className="p-1.5 rounded-full text-muted-foreground hover:text-ink hover:bg-white transition-colors">
        <X size={14} />
      </button>
    </div>
  );
}
